// @flow
import * as React from 'react';
import AsideAlert from '../AsideAlert';
import { SubmitButton } from '../../Common';
import { ModerationState, Observation } from '../../../models';
import {
  actionAside as actionAsideCss,
  actionAsideModeratorComments,
  actionAsideSectionCustomObservationHeader as actionAsideCOHeadingCss,
  actionAsideSectionMerchantNameSubheader as actionAsideMerchantNameHeadingCss,
} from './ActionAside.scss';
import ActionAsideSection from './ActionAsideSection';
import ObservationBadges, { ObservationTimestamp } from '../ObservationBadges';

const getSecondOpinionObservation = (state: ModerationState): ?Observation => {
  const pwrObservations = state.savedObservations.get(1);

  return pwrObservations
    ? pwrObservations.get(Observation.SecondOpinionCode)
    : undefined;
};

const ActionAsideSecondOpinion = (props: {
  pending: boolean,
  onSubmit: Function,
  standardObservationButtons: Array<React.Element<any>>,
  customObservationButtons: Array<React.Element<any>>,
  moderationState: ModerationState,
  merchantName: string,
}) => {
  const {
    pending,
    onSubmit,
    standardObservationButtons,
    customObservationButtons,
    moderationState,
    merchantName,
  } = props;
  const secondOpinionObservation = getSecondOpinionObservation(moderationState);
  const buttonLabel = ModerationState.isModified(moderationState, 1)
    ? 'Update'
    : 'Dismiss';

  return (
    <div className={actionAsideCss}>
      <ActionAsideSection.First>
        <AsideAlert style={{ marginBottom: '0.825em' }}>
          Second Opinion Needed
        </AsideAlert>
        <SubmitButton
          pending={pending}
          onClick={onSubmit}
          label={buttonLabel}
          className="w-100"
        />
      </ActionAsideSection.First>
      <ActionAsideSection>
        {secondOpinionObservation && (
          <ObservationTimestamp
            observation={secondOpinionObservation}
            showUserInfo
          />
        )}
        <ObservationBadges moderationState={moderationState} />
        {secondOpinionObservation &&
          secondOpinionObservation.observation_data.comments && (
            <span className={actionAsideModeratorComments}>
              "{secondOpinionObservation.observation_data.comments}"
            </span>
          )}
      </ActionAsideSection>
      {customObservationButtons.length > 0 && (
        <ActionAsideSection>
          <h3 className={actionAsideCOHeadingCss}>Custom Observations for:</h3>
          <p className={actionAsideMerchantNameHeadingCss}>{merchantName}</p>
          {customObservationButtons}
        </ActionAsideSection>
      )}
      <ActionAsideSection heading="Standard Observations">
        {standardObservationButtons}
      </ActionAsideSection>
    </div>
  );
};

export default ActionAsideSecondOpinion;



// WEBPACK FOOTER //
// ./src/components/ModerationCard/PowerReviewsModerationCard/ActionAsideSecondOpinion.js